export default __webpack_public_path__ + "static/media/gold-volume-ar.d2e1fd31.png";